import Menu from "../Menu.js";

// const log = global.log.getLogger("f_mtac.ui.ConfirmationArea");
const AssistantArea = function () {
    let interaction_end = () => {
        $("#assistant_area").hide();
        $("#status_area").css("display", null);
        $("body").off("click.assistant_area.btn", "#assistant_area .btn");
    };
    this.interact = function () {
        if (Menu.currently_opened !== null) {
            Menu.close(Menu.currently_opened);
        }
        return new Promise((resolve) => {
            let handlers = {
                ok: () => {
                    interaction_end();
                    resolve(true);
                },
                cancel: () => {
                    interaction_end();
                    resolve(false);
                }
            };

            $("#status_area").hide();
            $("#assistant_area").css("display", null);
            $("body").on("click.assistant_area.btn", "#assistant_area .btn", (event) => {
                handlers[$(event.currentTarget).data("method")]();
            });
        });
    };
};
export default new AssistantArea();
